import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AuthState } from "../../../../context/auth/auth/reducer";
import { b64EncodeUnicode } from "../../../../utils/url";
import { IToastContext, ToastContext } from "../../../../providers/Toast";
import { GlobalLoadingContext, IGlobalLoadingContext } from "../../../../providers/GlobalLoading";
import { Event, EventSnippet, ZoomConfig } from "../../../../data/interfaces";
import { getSignature } from "../../../../context/events/action";
import { ZOOM_ROLES } from "../../../../data/enums";
import { mapEventToSnippet } from "../../../../utils/mapping";
import _environment from "../../../../_environment/_environment";
// @ts-ignore

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  event: Event;
  roomInitializedCallback: (res: boolean) => void;
}

const EventDetailZoomView = ({ event, roomInitializedCallback, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to toast manager hook that you may use to show toasts.
  const { openToast } = useContext<IToastContext>(ToastContext);

  // Access to loading manager provider that you may use to show and hide global loading
  const { hideGlobalLoading, showGlobalLoading } = useContext<IGlobalLoadingContext>(
    GlobalLoadingContext
  );

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------
  // Zoom signature
  const [signature, setSignature] = useState<string | null>(null);

  // Zoom Configuration
  const [zoomConfig, setZoomConfig] = useState<ZoomConfig | undefined>(undefined);

  // Room init
  const [isRoomInitialized, setIsRoomInitialized] = useState<boolean>(false);

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------
  const { user } = useSelector(({ authReducer }: { authReducer: AuthState }) => {
    return authReducer;
  });

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * Creates iFrame
   * @function
   *
   * @param url
   */
  const createIframe = (url: string): void => {
    const zoomIframe = document.createElement("iframe");
    zoomIframe.id = "room-iframe";
    /*zoomIframe.sandbox =
            "allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox";*/
    zoomIframe.allow = "microphone; camera; fullscreen;";
    zoomIframe.src = url;
    /*zoomIframe.style = "";*/
    const wrapper = document.getElementById("room-iframe-wrapper");
    if (wrapper) {
      if (typeof document.body.append === "function") {
        wrapper.append(zoomIframe);
      } else {
        wrapper.appendChild(zoomIframe);
      }
      setIsRoomInitialized(true);
    }
  };

  /**
   * Load signature for Zoom video
   * @function
   * @async
   *
   * @param params
   */
  const loadSignature = async (params: any) => {
    try {
      const data = await getSignature(params);

      setSignature(data);
    } catch (err) {
      console.error(err);
      openToast({
        type: "error",
        title: "errors.general.title",
        message: "errors.general.description",
        callback: () => {},
      });
    } finally {
    }
  };

  /**
   * Generates zoom join url
   * @function
   *
   * @param data
   */
  const getJoinUrl = (data: ZoomConfig): string => {
    let eventSnippet: EventSnippet = mapEventToSnippet(event);

    eventSnippet.image_url = null;

    return `${window.location.origin}/join-room?name=${data.name}&mn=${data.mn}&email=${
      data.email
    }&pwd=${data.pwd}&lang=${data.lang}&signature=${data.signature}&china=${data.china}&apiKey=${
      data.apiKey
    }&event=${JSON.stringify(eventSnippet)}`;
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[EventDetailZoomView] init");

    if (event.zoom) {
      setZoomConfig({
        apiKey: _environment.zoomApiKey,
        china: "0",
        email: "",
        lang: "en-US",
        role: 0,
        mn: event.zoom.meeting_id,
        name: "",
        pwd: event.zoom.meeting_psw,
        signature: "",
      });
    }
  };

  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[EventDetailZoomView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  /**
   * Hook to signature in order to set zoom config
   */
  useEffect(() => {
    if (signature) {
      if (zoomConfig && user) {
        setZoomConfig({
          ...zoomConfig,
          ...{
            signature,
            email: user.email,
            name: b64EncodeUnicode(`${user.firstname} ${user.lastname}`),
          },
        });
      }
    }
  }, [signature]);

  /**
   * Hook to zoomConfig in order to create meeting iframe
   */
  useEffect(() => {
    if (zoomConfig) {
      if (zoomConfig.signature) {
        const joinUrl = getJoinUrl(zoomConfig);
        createIframe(joinUrl);
        hideGlobalLoading();
      } else {
        loadSignature({
          apiKey: _environment.zoomApiKey,
          role: ZOOM_ROLES.ATTENDEE,
          meetingNumber: zoomConfig.mn,
        });
      }
    }
  }, [zoomConfig]);

  /**
   * Hook to isRoomInitialized in order to handle callback
   */
  useEffect(() => {
    roomInitializedCallback(isRoomInitialized);
  }, [isRoomInitialized]);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return <div></div>;
};
export default EventDetailZoomView;
